import React, { Component } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { XOKButton, XCancelButton, XInput, XSelect, XDatePicker } from '@/components/xqxc_ui';
import { SearchBox, SearchItem } from '@/components/Layout';
import TableBox from './components/TableBox';
import model from '@/reducers/audit/picturenickname/model';
import moment from 'moment';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import EDModal from './modal/ADModal';

class PictureNickname extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,//路由对象
        match: PropTypes.object,
        setBreadcrumbPaths: PropTypes.func,
        getPicturenicknames: PropTypes.func,
        picturenicknames: PropTypes.object,
        getStateEnum: PropTypes.func,
        stateEnum: PropTypes.array,
        getTypeEnum: PropTypes.func,
        typeEnum: PropTypes.array,
        getIdentityEnum: PropTypes.func,
        identityEnum: PropTypes.array,
    }

    static defaultProps = {
        picturenicknames: {
            dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0
        },
        auditStatus: []
    }

    state = {
        renderModal: false,
        modalParams: {},
        applicantTel: '',
        statusItem: {},
        typeItem: {},
        identityItem: {},
        startTime: '',
        endTime: '',
    }

    componentDidMount() {
        const { getStateEnum, getIdentityEnum, getTypeEnum, setBreadcrumbPaths, match } = this.props;
        setBreadcrumbPaths(match);
        getStateEnum({ enumName: 'AvatarNicknameAuditStateEnum' });
        getIdentityEnum({ enumName: 'AvatarNicknameUserTypeEnum' });
        getTypeEnum({ enumName: 'AvatarNicknameAuditTypeEnum' });
    }

    // 查询触发
    onSearch = (useCache) => {
        const { applicantTel, statusItem, typeItem, identityItem, startTime, endTime, pageNum, pageSize } = this.state;
        this.searchCache = {
            phone: applicantTel,
            auditType: typeItem.code,
            userType: identityItem.code,
            auditState: statusItem.code,
            startTime: startTime ? moment(startTime).format('YYYY-MM-DD') : undefined,
            endTime: endTime ? moment(endTime).format('YYYY-MM-DD') : undefined,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getPicturenicknames(this.searchCache);
        KeepAlive.saveCache({ ...this.searchCache, statusItem, identityItem, typeItem }); // 【第3步，缓存查询状态】
    }

    // 重置触发
    onReset = () => {
        this.setState({ startTime: '', endTime: '', applicantTel: '', statusItem: {}, typeItem: {}, identityItem: {}, }, () => {
            KeepAlive.saveResetFunc(this.onSearch); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    //分页改变
    onPageChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this.onSearch('useCache');
        });
    }

    //渲染弹框
    _renderModal = ({ renderModal = false, id = '', type = '', title = '' }) => {
        this.setState({ renderModal, modalParams: { id, type, title } });
    }

    //关闭弹框
    _closeModal = (update) => {
        this.setState({ renderModal: false, modalParams: {} }, () => {
            update && this.onSearch('useCache');
        })
    }

    render() {
        const { picturenicknames, stateEnum, typeEnum, identityEnum } = this.props;
        const { applicantTel, startTime, typeItem, identityItem, statusItem, endTime, modalParams, renderModal } = this.state;
        return <KeepAlive id='pictureNickname' render={(state) => {
            if (!this.state.__aliveInit) {
                this.setState({ ...state, __aliveInit: true }, () => {
                    this.onSearch('useCache'); // 【第1步：调用查询接口初始化数据】
                });
            }
        }}>
            <div className={styles.flexBoxContainer}>
                <SearchBox>
                    <SearchItem>
                        <XInput
                            label='手机号码'
                            placeholder='请输入手机号'
                            bindThis={this}
                            bindName='applicantTel'
                            value={applicantTel}
                            showLength={false}
                            maxLength={20}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='状态'
                            placeholder='请选择状态'
                            renderData={stateEnum}
                            bindThis={this}
                            bindName='statusItem'
                            dataIndex='value'
                            keyIndex='code'
                            value={statusItem.value}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='类型'
                            placeholder='请选择类型'
                            renderData={typeEnum}
                            bindThis={this}
                            bindName='typeItem'
                            dataIndex='value'
                            keyIndex='code'
                            value={typeItem.value}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='会员身份'
                            placeholder='请选择类型'
                            renderData={identityEnum}
                            bindThis={this}
                            bindName='identityItem'
                            dataIndex='value'
                            keyIndex='code'
                            value={identityItem.value}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XDatePicker
                            label='申请日期'
                            placeholder='请选择开始时间'
                            value={startTime}
                            bindThis={this}
                            bindName='startTime'
                            showTime={false}
                            disabledDate={current => {
                                if (current && endTime && current > endTime) {
                                    return true;
                                }
                            }}
                        />
                        <XDatePicker
                            style={{ marginRight: '20px' }}
                            placeholder='请选择结束时间'
                            value={endTime}
                            bindThis={this}
                            bindName='endTime'
                            showTime={false}
                            disabledDate={current => {
                                if (current && startTime && current < startTime) {
                                    return true;
                                }
                            }}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XOKButton
                            label='查询'
                            onClick={this.onSearch}
                        />
                        <XCancelButton
                            label='重置'
                            onClick={this.onReset}
                        />
                    </SearchItem>
                </SearchBox>
                <TableBox
                    renderModal={this._renderModal}
                    tableData={picturenicknames}
                    onPageChange={this.onPageChange}
                />
                {
                    renderModal &&
                    <EDModal closeModal={this._closeModal} modalParams={modalParams} />
                }
            </div>
        </KeepAlive>;
    }
}

export default connect(state => ({
    picturenicknames: state.picturenickname.picturenicknames,
    stateEnum: state.picturenickname.stateEnum,
    typeEnum: state.picturenickname.typeEnum,
    identityEnum: state.picturenickname.identityEnum,
}), {
    ...model.actions,
    setBreadcrumbPaths
})(PictureNickname);